import {createAction} from 'redux-actions';

const PREFIX = 'VANRENTALS_';

export const rentVan = createAction(`${PREFIX}RENT_VAN`);
export const rentVanSuccess = createAction(`${PREFIX}RENT_VAN_SUCCESS`, (payload) => payload);
export const rentVanFailure = createAction(`${PREFIX}RENT_VAN_FAILURE`, (payload) => payload);
